import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react';

import { cn } from '@nesso/ui/lib/utils';

import type {
    PracticeMemberUsageSortBy,
    PracticeMemberUsageSortDirection,
} from '@/entities/reporting';

type Props = {
    label: string;
    column: PracticeMemberUsageSortBy;
    align?: 'start' | 'end';
    sortBy: PracticeMemberUsageSortBy;
    sortDirection: PracticeMemberUsageSortDirection;
    onSort: (column: PracticeMemberUsageSortBy) => void;
};

// A neutral chevron marks every sortable header, not just the active one, so sortability is
// discoverable before any click.
export function ReportingPagePracticeMemberUsageTableSortHeader({
    label,
    column,
    align = 'start',
    sortBy,
    sortDirection,
    onSort,
}: Props) {
    const isActive = sortBy === column;
    const Icon = isActive ? (sortDirection === 'desc' ? ArrowDown : ArrowUp) : ChevronsUpDown;

    return (
        <button
            type="button"
            onClick={() => onSort(column)}
            aria-pressed={isActive}
            className={cn(
                'flex w-full cursor-pointer items-center gap-1',
                align === 'end' ? 'justify-end' : 'justify-start',
            )}
        >
            {label}
            <Icon className={cn('size-3.5', !isActive && 'opacity-50')} aria-hidden="true" />
        </button>
    );
}
